import React, { useCallback } from "react";
import { Reference } from "../../adapters/insights-agent/state/AppState.ts";
import { contextualRelevancyMapping } from "../../adapters/insights-agent/state/contextualRelevancyMapping.ts";
import { ExternalLinkIcon } from "../../ui-library/_icons/ExternalLinkIcon.tsx";
import { Checkbox } from "../../ui-library/Checkbox/Checkbox.tsx";
import styles from "./ReferenceBox.module.css";

export const ReferenceBox: React.FC<{
  reference: Pick<
    Reference,
    "id" | "title" | "sourceUrl" | "contextualRelevancy"
  >;
  onCheck?: (value: boolean, id: string) => void;
  checked: boolean;
}> = ({ reference, onCheck, checked }) => {
  const changeHandler = useCallback(
    (value: boolean) => {
      if (!onCheck) return;
      onCheck(value, reference.id);
    },
    [onCheck, reference.id],
  );
  const contextualRelevancyLevel: string | null =
    typeof reference.contextualRelevancy === "number"
      ? contextualRelevancyMapping[reference.contextualRelevancy]
      : null;
  return (
    <div className={styles.ReferenceBox}>
      {onCheck && (
        <div className={styles.Checkbox}>
          <Checkbox onChange={changeHandler} checked={checked} />
        </div>
      )}
      <div>
        <h3>
          <a
            href={reference.sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {reference.title} {reference.sourceUrl && <ExternalLinkIcon />}{" "}
            {typeof reference.contextualRelevancy === "number" && (
              <span
                className={styles.Label}
                title={
                  reference.contextualRelevancy > 0
                    ? `${contextualRelevancyLevel} relevancy level based on the curation goal`
                    : "This document is not applicable to the curation goal"
                }
              >
                {contextualRelevancyLevel}
              </span>
            )}
          </a>
        </h3>
      </div>
    </div>
  );
};
